export default "__VITE_ASSET__1ec6461b__"